import { render, staticRenderFns } from "./ApplicantResult.vue?vue&type=template&id=5ebb808e&scoped=true&"
import script from "./ApplicantResult.vue?vue&type=script&lang=js&"
export * from "./ApplicantResult.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantResult.vue?vue&type=style&index=0&id=5ebb808e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebb808e",
  null
  
)

export default component.exports